export const RESET_PASSWORD_FORM = 'RESET_PASSWORD_FORM';
